let localTransformTagName;
// Allows access to the transformTagName function at runtime to transform nested children.
// Stencil does not currently expose this.
function getNamespacedTagFor(tagName) {
  return new Proxy((tag) => tag, {
    apply(target, thisArg, args) {
      return Reflect.apply(localTransformTagName !== null && localTransformTagName !== void 0 ? localTransformTagName : target, thisArg, args);
    },
  })(tagName);
}
const setTransformTagName = (transform) => {
  localTransformTagName = transform;
};

export { getNamespacedTagFor as g, setTransformTagName as s };
